import React from 'react';
import { Statistic } from 'antd';

const CustomerBaseAppointmentCards = ({data}) => {

    const titles = {
        POSITIVE: 'OLUMLU RANDEVU',
        NEGATIVE: 'OLUMSUZ RANDEVU',
        WAITING: 'BEKLEYEN RANDEVU'
    }

    return(
        <React.Fragment>
            <Statistic title={titles[data.s]} value={data.c} />
        </React.Fragment>
    )
}

export default CustomerBaseAppointmentCards;